import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { setTabIndex, setVisibleTabs } from './actions';

const tabSelector = (state) => state.tabs;

export const useTabs = {
  state: () => {
    const tabs = useSelect(tabSelector);
    return tabs;
  },
  actions: () => {
    return {
      setTabIndex: useAction(setTabIndex),
      setVisibleTabs: useAction(setVisibleTabs),
    };
  },
};
